export default function Hero() {
  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-primary-100/40 blur-3xl"></div>
        <div className="absolute -bottom-20 -left-20 w-[400px] h-[400px] rounded-full bg-accent-100/30 blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 lg:px-10 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="w-full lg:w-[55%] flex flex-col items-start animate-fade-in-up">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-medium mb-5">
              <i className="ri-fire-line text-sm"></i>
              下拉式阅读 · 追更收藏 · 免费全集
            </span>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-5xl font-heading text-foreground-950 leading-tight mb-4">
              99漫画
              <span className="block text-2xl sm:text-3xl md:text-4xl mt-2 font-sans font-semibold text-foreground-800">
                推荐类似4399漫画网的免费好看漫画平台
              </span>
            </h1>

            <p className="text-base text-foreground-500 font-medium mb-3">
              韩漫日漫国漫全集大全 · 下拉式阅读 · 轻松追更收藏热门漫画
            </p>

            <p className="text-sm text-foreground-600 leading-relaxed max-w-xl mb-7">
              99漫画专注为漫迷打造高品质免费阅读体验，汇集海量韩漫、日漫、国漫全集大全资源。平台采用流畅下拉式阅读模式，无论你是喜欢热血少年番、悬疑推理条漫，还是甜蜜恋爱韩漫，都能在这里找到心头好。每日同步更新热门连载，追更不等待，收藏不迷路，随时随地畅享漫画世界的无限精彩。
            </p>

            <div className="flex flex-wrap items-center gap-5 md:gap-8 mb-7">
              <div className="flex flex-col items-start">
                <span className="text-2xl md:text-3xl font-heading text-primary-500">10000+</span>
                <span className="text-xs text-foreground-500">部漫画资源</span>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="flex flex-col items-start">
                <span className="text-2xl md:text-3xl font-heading text-accent-500">每日更新</span>
                <span className="text-xs text-foreground-500">同步追更不等待</span>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="flex flex-col items-start">
                <span className="text-2xl md:text-3xl font-heading text-primary-500">全免费</span>
                <span className="text-xs text-foreground-500">无需付费会员</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
              <a
                href="#index"
                onClick={(e) => handleScrollTo(e, '#index')}
                className="inline-flex items-center justify-center gap-2 px-7 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line"></i>
                开始阅读
              </a>
              <a
                href="#features"
                onClick={(e) => handleScrollTo(e, '#features')}
                className="inline-flex items-center justify-center gap-2 px-7 py-3 bg-background-100 text-foreground-700 rounded-full text-sm font-medium hover:bg-background-200 transition-colors border border-background-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line"></i>
                了解平台优势
              </a>
            </div>
          </div>

          <div className="w-full lg:w-[45%] animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-200/30 via-accent-100/20 to-background-50 rounded-2xl blur-xl"></div>
              <div className="relative bg-background-100/60 backdrop-blur-sm rounded-2xl border border-background-200/60 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20vibrant%20Japanese%20manga%20style%20illustration%20featuring%20dynamic%20comic%20panels%20with%20action%20scenes%20explosions%20speed%20lines%20and%20dramatic%20lighting%20effects%2C%20warm%20orange%20and%20coral%20color%20palette%20with%20dark%20ink%20accents%2C%20modern%20webtoon%20scrolling%20layout%20aesthetic%2C%20clean%20composition%20with%20soft%20cream%20background%2C%20highly%20stylized%20and%20artistic&width=800&height=1000&seq=hero-comic-01&orientation=portrait"
                  alt="99漫画 - 免费好看的韩漫日漫国漫在线阅读平台"
                  className="w-full h-auto object-cover"
                />
              </div>
              <div className="absolute -bottom-3 -right-3 bg-background-50 rounded-xl border border-background-200/60 px-4 py-2.5 flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>
                <span className="text-xs text-foreground-600 whitespace-nowrap">每日 06:00 更新</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}